import { createRequestReducer } from 'pobble-components/dist/redux-helpers'
import { combineReducers } from 'redux'

const PasswordRequired = combineReducers({
  sendPasswordRequest: createRequestReducer(
    'FSU_PASSWORD_REQUIRED:SEND_PASSWORD'
  )
})

export default PasswordRequired
